import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import View from '@ckeditor/ckeditor5-ui/src/view';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import buttonIcon from '../theme/icons/icon.svg';
import ScribensPluginCommand from './plugincommand';
import '../dist/main';
import '../theme/styles.css';

export default class ScribensPluginUI extends Plugin {
  afterInit() {
    const editor = this.editor;
    const config = editor.config.get('scribens') || {};
    const langEditor = editor.config.get('language') || 'fr';
    const limitEditor = config.limit || null;

    window.chrome.i18n.lang = config.lang || langEditor.content || langEditor;

    editor.commands.add('scribensCheck', new ScribensPluginCommand(editor));

    editor.ui.componentFactory.add('scribensPlugin', locale => {
      const command = editor.commands.get('scribensCheck');
      const view = new ButtonView(locale);

      view.set({
        label: 'Scribens',
        icon: buttonIcon,
        tooltip: true,
        isError: false,
      });

      view.bind('isOn', 'isEnabled').to(command, 'isBusy', 'isEnabled');

      view.extendTemplate({
        attributes: {
          class: [
            'ck-scribensplugin-button',
            view.bindTemplate.if('isOn', 'ck-scribensplugin_status-pending'),
            view.bindTemplate.if('isError', 'ck-scribensplugin_status-error'),
          ]
        }
      });

      const child = new View();
      child.setTemplate({
        tag: 'span',
        attributes: {
          class: [
            'ck',
            'ck-scribensplugin__spinner-container',
          ]
        },
        children: this.createCollection(),
      });
      view.children.add(child);

      this.listenTo(view, 'execute', () => {
        editor.execute('scribensCheck', {
          buttonElement: view.element,
          command: command,
          limit: limitEditor,
          api_key: config.api_key,
        });
      });

      // this.auth(config.email, config.password)
      //   .then(res => {
      //     const isEnabled = Boolean(res);
      //     //command.isEnabled = isEnabled;
      //     view.isError = !isEnabled;

      //     if (!isEnabled) {
      //       view.fire('execute');

      //       setTimeout(() => { view.element.dispatchEvent(new Event('click')); }, 500);
      //     }
      //   });

      return view;
    });
  }

  auth(email, password) {
    return window.ckeditor_scribens_auth(email, password);
  }

  createCollection() {
    return [
      {
        tag: 'span',
        attributes: {
          class: [
            'ck',
            'ck-scribensplugin__spinner',
          ]
        }
      },
      {
        tag: 'span',
        attributes: {
          class: [
            'ck',
            'ck-scribensplugin__awaitupdate',
          ]
        }
      },
    ];
  }
}